import React from 'react'
import { Card, Checkbox, Input } from 'antd';
import { fixControlledValue } from 'antd/lib/input/Input';

const W4FormStep2 = (props) => {
  const {
    w4Form, setW4Form,
    disableAll
  } = props;

  const handleChange = (e) => {
    const { value } = e.target
    let new_value = (value ?? '') == '' ? 0 : parseInt(value);
    setW4Form({
      ...w4Form, ...{
        step2WithholdAmount: parseInt(new_value)
      }
    })
  }

  const handleKeyUp = (e) => {
    const { keyCode } = e
    if (keyCode == 189) {
      setW4Form({
        ...w4Form, ...{
          step2WithholdAmount: 0
        }
      })
    }
  }

  return (
    <Card type="inner" title={'Step 2: Multiple Jobs or Spouse Works'}>
      <Checkbox
        disabled={disableAll}
        checked={w4Form.multipleJobsOnlyInd}
        onChange={(e) => {
          setW4Form({ ...w4Form, ...{ multipleJobsOnlyInd: e.target.checked } });
        }}
      >
        You have more than one job at a time
        {
          (w4Form.isMarried === true) ?
            (
              <span>, or you are married filing jointly and your spouse also works</span>
            ) : (<></>)
        }.
      </Checkbox>
      {
        (w4Form.multipleJobsOnlyInd) ?
          (
            <>
              <br />    <br />
              <p style={{ marginBottom: '1em' }}>Do only one of the following:</p>
              <ul>
                <li>
                  <b style={{ paddingRight: '1em', marginLeft: '1em' }}>(a)</b>
                  Use the estimator at <a href='http://www.irs.gov/W4App' target='_blank'>www.irs.gov/W4App</a> to help determine the most accurate withholding and then enter the result in this field.
                  <Input prefix="$"
                    style={{ width: '6em' }}
                    type='number'
                    min='0'
                    disabled={disableAll}
                    name='step2WithholdAmount'
                    value={w4Form.step2WithholdAmount}
                    onChange={e => handleChange(e)}
                    onKeyUp={handleKeyUp}
                  />
                </li>
                <li>
                  <b style={{ paddingRight: '1em', marginLeft: '1em' }}>(b)</b>
                  Use the Multiple Jobs Worksheet available on page# 3 of W-4 form (you can download W-4 form using the following link - <a href='https://www.irs.gov/pub/irs-pdf/fw4.pdf' target='_blank'>https://www.irs.gov/pub/irs-pdf/fw4.pdf</a>) to determine roughly accurate withholding.
                </li>
                <li>
                  <b style={{ paddingRight: '1em', marginLeft: '1em' }}>(c)</b>
                  If there are only two jobs total, you may select this option. Make the same selection on Form W-4 for the other job. This option is accurate for jobs with similar pay; otherwise, more tax than necessary may be withheld.
                </li>
              </ul>
              <p style={{ marginTop: '1em' }}>TIP: To be accurate, submit a 2021 Form W-4 for all other jobs. If you or your spouse have self-employment income, including as an independent contractor, use the estimator.</p>
            </>
          ) : (<></>)
      }
    </Card>
  )
}
export default W4FormStep2
